.items {
  display: flex;
  flex-direction: column;
  flex: 1;
  user-select: none;
  gap: 0.5em;
}

.item {
  /* padding-bottom: 5px; */
  display: flex;
  gap: 0.5em;
}

.itemButton {
  width: 25px;
  border-radius: 0;
  border: 0;
  background: var(--grey-15);
  transition: 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.itemButton:not([disabled]) {
  color: var(--text);
}

.itemButton[disabled] {
  color: var(--text-disabled);
}

.itemButton:not([disabled]):hover {
  background: var(--grey-40);
  cursor: pointer;
}

.itemButton svg {
  width: 15px;
}
